import { jsxs as p, jsx as r } from "react/jsx-runtime";
import n from "../DiscountIcon/DiscountIcon.js";
import t from "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import s from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import m from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import "@propify-tenant-client/common";
import e from "classnames";
const l = s({
  container: {
    backgroundColor: "#A2DAC7",
    width: "fit-content",
    borderRadius: "10px 10px 0px 0px"
  },
  text: {
    fontSize: "16px",
    lineHeight: "20px"
  },
  title: {
    color: "white",
    fontWeight: 600,
    textTransform: "uppercase"
  },
  promotion: {
    backgroundColor: "rgba(162, 218, 199, 0.2)",
    border: "1px dashed #A2DAC7",
    borderRadius: "0px 8px 8px 8px",
    fontWeight: 500
  },
  img: {
    backgroundColor: "rgba(162, 218, 199, 0.2)",
    border: "1px dashed #A2DAC7",
    borderRadius: "0px 8px 8px 0px"
  }
}), so = ({ featuredPromotions: a }) => {
  const o = l();
  return /* @__PURE__ */ p(t, { children: [
    /* @__PURE__ */ r(t, { className: o.container, pb: 1, pl: 2, pr: 2, pt: 1, children: /* @__PURE__ */ r(m, { variant: "h6", className: e(o.text, o.title), children: "Promotion Available" }) }),
    /* @__PURE__ */ p(
      t,
      {
        display: "flex",
        mb: 1,
        justifyContent: "space-between",
        className: e(o.text, o.promotion),
        children: [
          /* @__PURE__ */ r(t, { p: 2, children: a.map((i) => /* @__PURE__ */ r(m, { variant: "body2", children: i }, i)) }),
          /* @__PURE__ */ r(t, { p: 2, display: "flex", alignItems: "center", className: o.img, children: /* @__PURE__ */ r(n, {}) })
        ]
      }
    )
  ] });
};
export {
  so as default
};
//# sourceMappingURL=PromotionSection.js.map
